<nz-modal i18n-nzTitle [nzVisible]="isVisible" (nzOnOk)="onOk()" (nzOnCancel)="cancel()"
  [nzFooter]="footer"
  [nzMaskStyle]="{ 'pointer-events': 'none' }"
  nzWrapClassName="nonblocking-dialog"
  nzTitle="Which PO this batch continues?">
  <ng-container *nzModalContent>
    <nz-page-header-content>
      <nz-descriptions nzSize="middle" [nzColumn]="1" nzBordered>
        <nz-descriptions-item i18n-nzTitle nzTitle="Quantity">{{this.batch?.producingQuantity}}</nz-descriptions-item>
        <nz-descriptions-item i18n-nzTitle nzTitle="Formulation">{{this.color}}</nz-descriptions-item>
      </nz-descriptions>
    </nz-page-header-content>
    <nz-divider></nz-divider>

    <nz-row>
      <nz-col nzSpan="24">
        @if ((options$ | async); as options) {
          <nz-select [nzDisabled]="options.length <=1" i18n-nzPlaceHolder [(ngModel)]="selection" [compareWith]="compareFn" nzPlaceHolder="Select a PO to continue">
            @for (o of options; track o) {
              <nz-option [nzValue]="o"
              [nzLabel]="o.poName + ' / ' + (o.sequenceInPo+1) + ' | ' + o.state"></nz-option>
            }
          </nz-select>
        }
      </nz-col>
    </nz-row>
  </ng-container>
</nz-modal>
